import {Box, Grid, Paper, Typography} from "@mui/material";
import {red} from "@mui/material/colors";

function ErrosProcessamento({ocorrencia}) {
    if (!ocorrencia?.resposta) {
        return null;
    }

    if (
        !ocorrencia.resposta.error &&
        !ocorrencia.resposta.raw &&
        !ocorrencia.resposta.mensagem &&
        !ocorrencia.resposta.mensagemValidacaoCampos &&
        !ocorrencia.resposta.erros &&
        !ocorrencia.resposta.objetoErro
    ) {
        return null;
    }

    const erros = ocorrencia.resposta.erros;
    const objetoErro = ocorrencia.resposta.objetoErro;
    const mensagemValidacaoCampos = ocorrencia.resposta.mensagemValidacaoCampos;

    return (
        <>
            {erros?.length > 0 && (
                <Box
                    component={Paper}
                    padding={2}
                    sx={{backgroundColor: red[50]}}
                    marginBottom={0}
                >
                    <Typography
                        variant="h6"
                        sx={{fontSize: "1rem"}}
                        gutterBottom
                    >
                        Erros
                    </Typography>
                    <Grid container spacing={2}>
                        {erros.map((erro) => (
                            <Grid item xs={12} key={erro.id}>
                                <Typography
                                    variant="body2"
                                    sx={{fontWeight: "bold"}}
                                >
                                    Erro e-Sfinge: {erro.idCodigoErro}
                                </Typography>
                                <Typography variant="body2">
                                    {erro.mensagem}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
            {mensagemValidacaoCampos?.length > 0 && (
                <Box
                    component={Paper}
                    padding={2}
                    sx={{backgroundColor: red[50]}}
                    marginBottom={0}
                >
                    <Typography
                        variant="h6"
                        sx={{fontSize: "1rem"}}
                        gutterBottom
                    >
                        Erros
                    </Typography>
                    <Grid container spacing={1}>
                        {mensagemValidacaoCampos.map((erro, index) => (
                            <Grid item xs={12} key={erro.id || index}>
                                <Typography
                                    variant="body2"
                                    sx={{fontWeight: "bold", mt: 1}}
                                >
                                    Erro e-Sfinge: {ocorrencia.resposta.erro}
                                </Typography>
                                <Typography variant="body2">
                                    {erro.mensagem}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
            {Array.isArray(objetoErro) && objetoErro.length > 0 && (
                <Box
                    component={Paper}
                    padding={2}
                    sx={{backgroundColor: red[50]}}
                    marginBottom={0}
                >
                    <Typography
                        variant="h6"
                        sx={{fontSize: "1rem"}}
                        gutterBottom
                    >
                        Restrições
                    </Typography>
                    <Grid container spacing={2}>
                        {objetoErro.map((restricao) => (
                            <Grid item xs={12} key={restricao.id}>
                                <Typography
                                    variant="body2"
                                    sx={{fontWeight: "bold", mt: 1}}
                                >
                                    Restrição e-Sfinge:{" "}
                                    {restricao.codigoRestricao} | Impeditivo:{" "}
                                    {restricao.indicativoRestricaoImpeditivo}
                                </Typography>

                                <Typography variant="body2">
                                    {restricao.descricaoRestricao}
                                </Typography>

                                <Typography variant="body2">
                                    {ocorrencia.resposta.mensagem}
                                </Typography>

                                {restricao.complementoMensagem && (
                                    <Typography
                                        variant="body2"
                                        sx={{fontStyle: "italic"}}
                                    >
                                        {restricao.complementoMensagem}
                                    </Typography>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
            {ocorrencia.resposta.error && (
                <Box
                    component={Paper}
                    padding={2}
                    sx={{backgroundColor: red[50]}}
                    marginBottom={0}
                >
                    <Typography
                        variant="h6"
                        sx={{fontSize: "1rem"}}
                        gutterBottom
                    >
                        Erros
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item key={0}>
                            <Typography variant="body2">
                                {ocorrencia.resposta.error}
                            </Typography>
                            {ocorrencia.resposta.message && (
                                <Typography variant="body2">
                                    {ocorrencia.resposta.message}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            )}

            {ocorrencia.resposta.raw && (
                <Box
                    component={Paper}
                    padding={2}
                    sx={{backgroundColor: red[50]}}
                    marginBottom={0}
                >
                    <Typography
                        variant="h6"
                        sx={{fontSize: "1rem"}}
                        gutterBottom
                    >
                        Erros
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item key={0}>
                            <Typography
                                variant="body2"
                                sx={{fontWeight: "bold"}}
                            >
                                Erros do Conector:
                            </Typography>
                            {ocorrencia.resposta.raw && (
                                <Typography variant="body2">
                                    {ocorrencia.resposta.raw}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            )}
        </>
    );
}

export default ErrosProcessamento;
